module.exports = __webpack_public_path__ + "img/Frente-35-02 open.25ebf7f3.jpg";